import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './routes';
import axios from 'axios';
import Vidle from 'v-idle'
import * as VueGoogleMaps from 'vue2-google-maps';


Vue.use(Vidle)
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyBiapGKGLf6NCzdMIEg_zt4HB5EYL2f20Q'
     key: 'AIzaSyAYxoLhSiGq4C4dXuKJzLipDrwYVlbD4Yk'
  },
  installComponents: true
});

// Vue.prototype.$env = 'DEV';
Vue.prototype.$env = 'UAT';
Vue.prototype.$http = axios.create({
  // !!!!!!!!! API DEV !!!!!!!!!!!!!!
  //baseURL: 'https://apigwuat.dexagroup.com/imaps/'
  //baseURL: 'http://192.168.3.117:30903/iscapsdev/api/cms/',
  //baseURL: 'http://localhost:8335/' // dev
  //baseURL: 'http://192.168.74.211:30335/' 
  // baseURL: 'https://imaps.anugrah-argon.com/iscapsdev/api/cms/',
  

  // !!!!!!!!! API PROD !!!!!!!!!!!!!!
    //  baseURL: 'https://imaps.anugrah-argon.com/api/cms/',
     baseURL: 'https://apigw.dexagroup.com/imaps/'
})
//dev
//Vue.prototype.$apiKey = '7R7h4H3H25qROZE5Qb7LOqRZKHJIPP64'
//prod
Vue.prototype.$apiKey = 'Wm1s8luS779BIYZ8QFlvS9r8nPHnZnRc'
Vue.config.productionTip = false
new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
//dev Imaps = http://192.168.74.211:30373/login